import VerticalFormStepper from './VerticalFormStepper';

export default VerticalFormStepper;
